"use client";
import cl from "classnames";
import { useState } from "react";
import IconChevron from "@/assets/icons/i-chevron.svg";
import LogoDodobrands from "@/assets/logo-dodobrands.svg";
import { Button } from "@/landing/components/Button";
import IconTg from "@/../public/images/landing/tg.png";
import IconIg from "@/../public/images/landing/ig.png";
import IconWa from "@/../public/images/landing/wa.png";
import IconTt from "@/../public/images/landing/tt.png";
import Image from "next/image";
import useClientAnalytics from "@/hooks/useClientAnalytics";
import IconCross from "@/assets/icons/i-cross.svg";
import styles from "./Footer.module.css";

type Props = {
  translations: {
    [key: string]: string;
  };
  termLink: string;
  privacyLink: string;
};

export const Footer = ({
  translations,
  termLink,
  privacyLink
}: React.PropsWithChildren<Props>) => {
  const { trackEvent } = useClientAnalytics();
  const [email, onChangeEmail] = useState("");
  const [subscribed, onSubscribed] = useState(false);

  const t = (key: string) => translations[key] || "";

  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChangeEmail(e.target.value);
  };

  const handleKeyDownEmail = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSendEmail();
    }
  };

  const handleClear = () => {
    onChangeEmail("");
  };

  const handleSendEmail = () => {
    trackEvent.TapToSubscribeEmail({
      email
    });

    onSubscribed(true);
  };

  return (
    <footer className={styles.root}>
      <div className={styles.contact}>
        <h2 className={styles.title}>{t("LANDING_FOOTER_CONTACT_US")}</h2>
        <div className={styles.subtitle}>{t("LANDING_FOOTER_FEEDBACK")}</div>
        <a
          href={"mailto:" + "info@menusa.app"}
          className={styles.email}
        >
          {"info@menusa.app"} ↗
        </a>
        <div className={styles.social}>
          <a className={styles.socialIcon} href="https://t.me/menusa_team">
            <Image src={IconTg} alt="telegram" width={32} height={32} />
          </a>
          <a className={styles.socialIcon} href="https://chat.whatsapp.com/JyaFH8iFaEOGBmiCN7Q5g8">
            <Image src={IconWa} alt="whatsapp" width={32} height={32} />
          </a>
          <a className={styles.socialIcon} href="https://www.instagram.com/menusa.app/">
            <Image src={IconIg} alt="instagram" width={32} height={32} />
          </a>
          <a className={styles.socialIcon} href="https://www.tiktok.com/@menusa.app">
            <Image src={IconTt} alt="tiktok" width={32} height={32} />
          </a>
        </div>
      </div>
      {/* <div className={styles.subscribe}>
        <div className={styles.title}>{t("LANDING_FOOTER_SUBSCRIBE")}</div>
        <div className={styles.subtitle}>
          {t("LANDING_FOOTER_SUBSCRIBE_SUBTITLE")}
        </div>
        <div className={styles.subscribeControls}>
          <input
            className={cl(styles.input, email && styles.active)}
            value={email}
            onChange={handleChangeEmail}
            onKeyDown={handleKeyDownEmail}
            disabled={subscribed}
            placeholder="mail"
          />
          {!subscribed && (
            <Button
              data-button="subscribe"
              className={cl(styles.clearButton, email && styles.active)}
              onClick={handleClear}
            >
              <IconCross className={styles.iconCross} />
            </Button>
          )}
          <Button
            className={cl(
              styles.inputButton,
              email && styles.active,
              subscribed && styles.done
            )}
            onClick={handleSendEmail}
          >
            {subscribed ? "✓" : <IconChevron />}
          </Button>
        </div>
      </div> */}
      <div className={styles.docs}>
        <div className={styles.logo}>
          <a
            className={styles.copyright_link}
            href="https://dodobrands.io/"
            target="_blank"
          >
            <LogoDodobrands className={styles.copyright_logo} />
          </a>
        </div>
        <div className={styles.rights}>
          © {new Date().getFullYear()} {t("LANDING_FOOTER_RIGHTS")}
        </div>
        <div className={styles.legal}>
          <a href={privacyLink} target="_blank" className={styles.link}>
            {t("LANDING_FOOTER_PRIVACY_POLICY")} ↗
          </a>
          <a href={termLink} target="_blank" className={styles.link}>
            {t("LANDING_FOOTER_TERMS_USE")} ↗
          </a>
        </div>
      </div>
    </footer>
  );
};
